// @flow
import * as React from 'react';

import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import type { CartConfiguration } from '@gandi/cart';
import { notifySuccess, notifyDanger } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

import { applyEmptyTemplate } from '../modules/actions';

import styles from './BottomLinks.scss';

type Props = {
  name: string,
  changeURL: string | false,
  removeLink: boolean,
  configuration: CartConfiguration,
};

export default function BottomLinks({
  name,
  changeURL,
  removeLink,
  configuration,
}: Props): React.Node {
  const { __ } = useTranslator();
  const dispatch = useDispatch();
  const [removing, setRemoving] = React.useState(false);

  return (
    <>
      <strong>{name}</strong>{' '}
      {changeURL && <Link to={changeURL}>{__('Change')}</Link>}
      {removeLink && (
        <>
          <span className={styles.separator} />
          <Button
            loading={removing}
            onClick={async () => {
              setRemoving(true);
              try {
                await dispatch(applyEmptyTemplate(configuration));
                dispatch(
                  notifySuccess({
                    title: __(
                      'Configuration template has been removed successfully.',
                    ),
                  }),
                );
              } catch (error) {
                setRemoving(false);
                dispatch(
                  notifyDanger({
                    title: __(
                      'Configuration template can not be removed at this time.',
                    ),
                  }),
                );
              }
            }}
            kind="link"
            type="button"
          >
            {__('Remove')}
          </Button>
        </>
      )}
    </>
  );
}
